import { Navigate, Link } from 'react-router-dom';
import { useUser } from '../providers/UserProvider';

interface AdminRouteProps {
  children: React.ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps) {
  // Gated on the capability, not on admin mode (issue #889): the toggle governs
  // what gets *drawn* in the reader, so a direct link to an admin page still
  // works. The links that lead here only appear in admin mode.
  const { isLoggedIn, isAdminUser } = useUser();
  if (!isLoggedIn) return <Navigate to="/login" replace />;
  if (!isAdminUser) {
    return (
      <div className="auth-shell">
        <div className="auth-panel">
          <div className="auth-brand">Kingfisher</div>
          <h1>Forbidden</h1>
          <p className="auth-subtitle">Only admins can access this page.</p>
          <div className="auth-footer"><Link to="/tldr">Back to reader</Link></div>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
